<template>
  <div>
    <h1 class="ya-te-page-title mb-[3.75rem] mt-5 text-center font-bold leading-none md:mb-20">
      特定商取引法に関する表示
    </h1>
    <div class="w-full leading-loose">
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          会社名
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          株式会社ブリューアス
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          代表者
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          代表取締役社長 安川 昌平
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          所在地
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          東京都渋谷区渋谷一丁目2番5号
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          問い合わせ先
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          <a href="mailto:support@techacademy.jp">support@techacademy.jp</a>
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          電話番号
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          上記記載のメールアドレスへご連絡いただければ、速やかに電話番号をご案内いたします。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          お支払い方法
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          指定口座への銀行振込、クレジットカード決済、コンビニ決済、Amazon Pay、PayPay
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          販売価格
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          各コース詳細ページに表示された価格に基づきます。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          提供期間
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          各コース詳細ページに表示された期間に基づきます。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          お支払い期限
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          申込日当日を含めて3営業日以内（土日祝日を除く）<br>
          ※申込日が土日祝日の場合は、翌営業日を申込日とします。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          コース代金以外の料金
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          コース代金以外に料金がかかる場合は、コース詳細ページに別途記載いたします。なおサービスの提供を受けるために必要な、コンピューター、スマートフォン、マイクやウェブカメラ、通信回線その他の通信環境等は、お客様の費用と責任において準備し維持するものとします。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          キャンセル等その他の事項
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          ＜クーリング・オフについて＞<br>
          本サービスはクーリング・オフ適用対象外です。<br><br>
          ＜サービス提供開始前のキャンセルについて＞<br>
          キャンセル可能です。受講開始にかかわらず、学習システム（カリキュラム）にログインされた後のご返金・コース変更はいたしかねますのでご了承下さい。<br>
          なおログイン実施前かつ、受講開始日の1営業日前までであれば、振込手数料を引いて全額返金いたします。（受付：平日10時〜18時）<br><br>
          ＜サービス提供開始後のキャンセルについて＞<br>
          サービスの性質上、サービス提供開始後のお客様都合によるキャンセルはお受けしておりません。
        </div>
      </div>
      <div class="gap-8 border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          動作環境
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          各コース詳細ページに表示された動作環境に基づきます。
        </div>
      </div>
      <div class="gap-8 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 w-full text-center font-bold lg:mb-0 lg:w-1/3 lg:font-normal">
          個人情報のお取り扱い
        </div>
        <div class="w-full text-center lg:w-2/3 lg:text-left">
          <span>取り扱いの詳細については、</span>
          <a
            v-if="isBiz"
            href="/ly/privacypolicy-biz"
          >プライバシーポリシー</a>
          <a
            v-else
            href="/ly/privacypolicy"
          >プライバシーポリシー</a>
          <span>をご参照下さい。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// /ly/lawと/ly/law-bizでリンクを切り替える
const route = useRoute()
const isBiz = computed(() => route.path.endsWith('-biz'))
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');
</style>
